<template>
    <div id="upcoming-shows">
        <h2 class="section-title">Upcoming Shows</h2>
    <div class="images-container">
        <h3>Sleepytime Gorilla Museum</h3>
    <h4>May 12th/2025 @ Headliners in Louisville, KY</h4>
    <h4>doors: 7pm, Music @ 8pm</h4>
        <div style="display: flex; flex-direction: row; justify-content: center;">
            <img src="../assets/SGM-tour.jpg" class="show-image">
        </div>
        <a href="https://www.etix.com/ticket/p/82488856/sleepytime-gorilla-museum-with-isolation-tank-ensemble-louisville-headliners-music-hall"
            target="blank"><button><h4>Get Tickets before they sell out!</h4></button>
        </a>
    </div>
    </div>

</template>

<script>

export default {
    name: 'UpcomingShows',
}

</script>

<style scoped>

.show-image {
    max-width: 500px;
    width: 80%;
    border: 4px solid black;
}
.images-container {
    text-align: center;
}


</style>